module.exports = __webpack_public_path__ + "static/media/power-def5.dd18047c.png";